import React from 'react';
import { Outlet } from 'react-router-dom';
import { theme } from 'antd';

/**
 * A layout component for public-facing pages like Login and Registration.
 * It applies the application's background color and centers the content.
 */
const PublicLayout: React.FC = () => {
  const { token } = theme.useToken();

  return (
    <div style={{
      backgroundColor: token.colorBgLayout,
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Outlet />
    </div>
  );
};

export default PublicLayout;